import { useEditor, useValue } from "tldraw";

/**
 * The zoom badge, spoken as a drafter's scale: 1 page unit is 1 inch, so at
 * 96 css-px per screen inch the effective scale ratio is 96 / zoom, snapped
 * to the nearest standard architectural scale for display.
 */
const STANDARD_SCALES: Array<[string, number]> = [
  [`4x full size`, 0.25],
  [`2x full size`, 0.5],
  [`12" = 1'-0"`, 1],
  [`6" = 1'-0"`, 2],
  [`3" = 1'-0"`, 4],
  [`1-1/2" = 1'-0"`, 8],
  [`1" = 1'-0"`, 12],
  [`3/4" = 1'-0"`, 16],
  [`1/2" = 1'-0"`, 24],
  [`3/8" = 1'-0"`, 32],
  [`1/4" = 1'-0"`, 48],
  [`3/16" = 1'-0"`, 64],
  [`1/8" = 1'-0"`, 96],
  [`3/32" = 1'-0"`, 128],
  [`1/16" = 1'-0"`, 192],
  [`1/32" = 1'-0"`, 384],
];

export function nearestArchitecturalScale(zoom: number): string {
  const ratio = 96 / zoom;
  let best = STANDARD_SCALES[0]!;
  for (const candidate of STANDARD_SCALES) {
    if (
      Math.abs(Math.log(candidate[1] / ratio)) <
      Math.abs(Math.log(best[1] / ratio))
    ) {
      best = candidate;
    }
  }
  return `≈ ${best[0]}`;
}

export function ScaleBadge() {
  const editor = useEditor();
  const zoom = useValue("zoom", () => editor.getZoomLevel(), [editor]);
  return (
    <div
      style={{
        position: "absolute",
        bottom: 8,
        right: 8,
        pointerEvents: "none",
        fontFamily: "var(--tl-font-draw)",
        fontSize: 12,
        color: "var(--tl-color-text-1)",
        background: "var(--tl-color-panel)",
        border: "1px solid var(--tl-color-divider)",
        borderRadius: 4,
        padding: "2px 8px",
      }}
    >
      {nearestArchitecturalScale(zoom)}
    </div>
  );
}
